/**
 *
 * Landlord
 *
 */

import Button from 'components/Button';
import { find_tenants } from 'data_jsons/find_tenants';
import Heading2 from 'components/Heading/H2';
import Image from 'components/Image';
import Layout from 'components/Layout';
import { calcResize, SpacedTitle } from 'components/Layout/styles';
import SEO from 'components/seo';
import ServicesCTA from 'components/ServicesCTA';
import AffiliationsSection from 'containers/AffiliationsSection';
import CTAWithImage from 'containers/CTAWithImage';
import HeroSection from 'containers/HeroSection';
import SplitSectionWithImage from 'containers/SplitSectionWithImage';
import CardsGridWithChildren from 'containers/CardsGridWithChildren';
import SplitSectionWithLabelledImage from 'containers/SplitSectionWithImage/SplitSectionWithLabelledImage';
import StarPng from 'images/rhombus-pink-pattern.png';
import Separator from 'images/svg/grey-separator.svg';
import { SHeroTitle, SParagraphHolder } from 'pages/HomePage/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import LandingFAQ from 'components/LandingFAQ';
import { find_tenants_faqs } from 'data_jsons/find_tenants_faq';
import RecentBlogPosts from 'components/RecentBlogPosts';

export const FindTenants = ({ pageContext }) => {
  return (
    <Layout
      navType="light"
      navLinkType={'light'}
      logoType={'light'}
      navBgColor="#ffffff"
      navLinkColor="#ffffff"
    >
      <SEO
        title="Find tenants faster and lower void times with Oasis Living"
        description="Find tenants faster and ensure low void times with Oasis Living; an online letting agent that puts landlords first. Improve your property letting experience"
        useTitleTemplate={false}
      />

      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
      </Helmet>
      <HeroSection
        // welcomeTitle="Welcome To Oasis Living"
        mainTitle={
          <SHeroTitle>
            Find tenants
            <br />
            <span className="highlight">FAST</span>
          </SHeroTitle>
        }
        subTitle={
          <>
            Advertise your property with us and we’ll advertise your property on
            all of the premium property search sites like Rightmove, Zoopla and
            more. Finding you tenants faster, for less.
            {/*<br />*/}
            {/*<Link to="/">Move in FAST while paying 0% in fees</Link>*/}
          </>
        }
        actions={
          <>
            <Button
              variant="full"
              $backgroundColor="accent"
              onClick="/list-property/"
              $withArrow={true}
              buttonID="tenant-find-list-my-property-hero"
            >
              List your property
            </Button>
          </>
        }
        slug={<>Rent with Oasis Living</>}
        backgroundImage={'find_tenants/find_tenants_hero_bg.jpg'}
      />

      <CardsGridWithChildren
        title="Finding you tenants faster, for less." // Only put text if cards are inline
        displayStarSvg
        isChildLeft={true}
        data={find_tenants}
        padding={true}
        inLine={true}
      />

      <AffiliationsSection />

      <SplitSectionWithImage
        margin="0"
        imageName="find_tenants/find_tenants_premium_ads.jpg"
        isImageVisibleMobile={false}
        displayStarSvg={true}
        mode="dark"
        hasCircleBg={true}
      >
        <ServicesCTA
          descriptionColor="#ffffff"
          titleChildren={
            <>
              <Heading2 text="Premium Advertising at an" colour="white" />
              <Heading2
                isUnderlined
                text="affordable cost"
                colour="pastel_blue"
              />
            </>
          }
          description="We know that being a property owner is a time-consuming business. THat’s why we are offering to lighten the load. When you sign up to Oasis Living to find tenants, we’ll take care of all of the property viewings for you. We use smart tech and AI to manage the bookings process more efficiently and effectively. We also have trained professionals that will conduct each viewing, ensuring to up-sell and promote the great qualities of your property."
          actionChildren={
            <>
              <Button
                $backgroundColor="rightmove"
                variant="full"
                buttonID="tenant-find-pm-ads-rightmove"
              />
              <Button
                $backgroundColor="zoopla"
                variant="full"
                buttonID="tenant-find-pm-ads-zoopla"
              />
            </>
          }
        />
      </SplitSectionWithImage>

      {/* 24/7 SUPPORT */}
      <SplitSectionWithImage
        margin="0"
        imageName="find_tenants_viewing.png"
        isImageVisibleMobile={false}
        displayStarSvg={true}
        starSvgPositionLeft={true}
        starSvgPositionTop={true}
        imageContainerPosition="static"
        starSvgMoveY="0"
        hasCircleBg={true}
        isImageLeft={true}
        starSvgWidth="75%"
        overflow={false}
        starMoveY={true}
      >
        <ServicesCTA
          mode="dark"
          titleChildren={
            <>
              <Heading2 text="Your viewings," display="inline-block" />
              <Heading2
                isUnderlined
                text="sorted"
                colour="primary"
                display="inline-block"
              />
            </>
          }
          description="We know that being a property owner is a time-consuming business. That’s why we are offering to lighten the load. When you sign up to Oasis Living to find tenants, we’ll take care of all of the property viewings for you. We use smart tech and AI to manage the bookings process more efficiently and effectively. We also have trained professionals that will conduct each viewing, ensuring to up-sell and promote the great qualities of your property."
          actionChildren={
            <>
              <Button
                margin="2em 0"
                $backgroundColor="accent"
                variant="full"
                $withArrow={true}
                onClick="/list-property/"
                buttonID="tenant-find-list-my-property-your-viewings"
              >
                List your property
              </Button>
            </>
          }
        />
      </SplitSectionWithImage>
      {/* / 24/7 SUPPORT */}

      <SplitSectionWithLabelledImage
        imageName="camera_one.png"
        isImageLeft
        displayStarSvg={true}
        startSvgMoveLeft="50%"
        starSvgPositionTop={true}
        starSvgMoveY="470px"
        starSvgWidth="100%"
        starSvgPositionRight="-50px"
        alignSelf={false}
        containerOverflowHidden={true}
        noBackground={true}
        photoLabel="premium_photos"
      >
        <Image filename="camera_two.png" />
        <SParagraphHolder className="mx-auto mx-lg-0">
          <SpacedTitle colorVariant="accentDark"> FEATURES </SpacedTitle>
          <Heading2
            className="text-center text-md-start"
            text="Capturing Quality"
            $extraStyle={`
              font-size: ${calcResize(37, 40)}; 
              `}
          />
          <Separator className="d-block mx-auto mx-md-0" />
          <Row>
            <Col md={6}>
              <p className="mt-3">
                Your property deserves to be seen at its very best. We use
                qualified professionals when taking listing photos of our
                properties to make sure each property looks amazing. Better
                photographs mean more viewings and less void time between
                tenants.
              </p>
            </Col>
            <Col md={6}>
              <p className="mt-3">
                No more dodgy phone pictures taken by unprofessional letting
                agents! Sign up today to discover premium property photography
                for a fraction of the price of a high street agent.
              </p>
            </Col>
          </Row>
        </SParagraphHolder>
      </SplitSectionWithLabelledImage>
      <SplitSectionWithImage
        margin="0"
        imageName="find_tenants/sofa-with-dog.png"
        isImageVisibleMobile={false}
        displayStarSvg={true}
        mode="dark"
        hasCircleBg={true}
      >
        <ServicesCTA
          // displayFeatures
          descriptionColor="#ffffff"
          titleChildren={
            <>
              <SpacedTitle colorVariant="accentDark">
                Intuitive Staging
              </SpacedTitle>
              <Heading2 isUnderlined text="Maximise" colour="primary" />
              <Heading2 text="Your Property's Potential" colour="white" />
            </>
          }
          description="At Oasis Living, we want to go the extra mile. We will stage your property during the photography session to ensure it looks appealing to potential tenants. It’s important that it’s easy for someone to imagine not just staying at your property but living there. We’ll make sure that everything looks incredible so that we can book more viewings and let your property fast!"
          actionChildren={
            <>
              <Button
                $backgroundColor="accent"
                variant="full"
                onClick="/landlord/property-management/"
                $withArrow={true}
                buttonID="tenant-find-view-pr-m-page"
              >
                View Property Management Page
              </Button>
            </>
          }
        />
      </SplitSectionWithImage>
      <RecentBlogPosts posts={pageContext.recentPosts} isSlider />
      <LandingFAQ data={find_tenants_faqs} theme="light_grey" />
      <CTAWithImage
        hideDotSVG={true}
        slug="List Your Property"
        mainText="Discover a better way to find tenants with Oasis Living and maximise your property's potential"
        btnText="List Your Property"
        filename="green_room_cta_image.jpg"
        onCLick="/list-property/"
        buttonID="tenant-find-list-your-property-discover"
      />
    </Layout>
  );
};

FindTenants.propTypes = {
  pageContext: PropTypes.any,
};

export default FindTenants;
